module.exports = {
  QUESTIONS: "QUESTIONS",
  STUDENT: "STUDENT",
  EXAM: "EXAM",
};
